import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IKBArtifact } from '../../interfaces/IBase-knowledge-catalog';
import { ChangeTrackerService } from '../../services/change-tracker.service';

@Component({
  selector: 'file-artifacts-table',
  templateUrl: './file-artifacts-table.component.html',
  styleUrls: ['./file-artifacts-table.component.scss']
})
export class FileArtifactsTableComponent {

  @Input() artifacts: IKBArtifact[] = [];
  @Output() removeFile = new EventEmitter<number>();
  @Output() artifactChanged = new EventEmitter<IKBArtifact>();

  constructor(private _changeTrackerService: ChangeTrackerService) { }

  get visibleArtifacts(): IKBArtifact[] {
    return this.artifacts.filter(artifact => !artifact.Deleted);
  }

  onRemoveFile(index: number): void {
    const visibleArtifact = this.visibleArtifacts[index];
    const originalIndex = this.artifacts.findIndex(artifact => artifact === visibleArtifact);
    this.removeFile.emit(originalIndex);
  }

  onArtifactFieldChange(artifact: IKBArtifact): void {
    this._changeTrackerService.markArtifactAsChanged(artifact);
    this.artifactChanged.emit(artifact);
  }

  trackByIndex(index: number, item: IKBArtifact): number {
    return index;
  }

}
